module.exports = __webpack_public_path__ + "static/img/logo9.d7334c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo9.png
// module id = 6Gua
// module chunks = 1